import { Col, Row, Table } from "react-bootstrap";
import classes from "./OverallAnalytics.module.css";
import { useState } from "react";
import QuestionWiseAnalysis from "../QuestionWiseAnalysis/QuestionWiseAnalysis";
import StudentToFocus from "../StudentToFocus/StudentToFocus";
import OverallStudentAnalysis from "../OverallStudentAnalysis/OverallStudentAnalysis";
import TopicToFocus from "../TopicToFocus/TopicToFocus";

const OverallAnalytics = () => {
  
  return (
    <div className={classes.grid}>
      {/*  */}
      <div className={classes.gCol}>
        <div className={classes.bordered}>
          <div className={classes.head}>
            <p className={classes.heading}>Overall Test Mark Analysis</p>
          </div>
          <div className={classes.line}></div>
          <div className={classes.section}>
            <Table responsive bordered className={classes.table}>
              <tbody>
                <tr>
                  <td>Test Name</td>
                  <td>Minimum Marks</td>
                  <td>Average Marks</td>
                  <td>Maximum Marks</td>
                </tr>
                <tr>
                  <th>Test Name</th>
                  <th>50</th>
                  <th>90</th>
                  <th>60</th>
                </tr>
              </tbody>
            </Table>
            <p className={classes.text}>Total No Of Students : 300</p>
            <p className={classes.text}>No Of Students Attempted test : 300</p>
            <p className={classes.text}>
              No Of Students Unattempted test : 300
            </p>
          </div>
        </div>
      </div>
      {/*  */}
      <div className={classes.gCol}>
        <div className={classes.bordered}>
          <QuestionWiseAnalysis/>
        </div>
      </div>
      {/*  */}
      {/*  */}
      <div className={`${classes.gCol} w-100`}>
        <div className={classes.bordered}>
          <StudentToFocus />
        </div>
      </div>
      {/*  */}
      <div className={`${classes.gCol} w-100`}>
        <div className={classes.bordered}>
          <TopicToFocus/>
        </div>
      </div>
      {/*  */}
      <div className={`${classes.gCol} w-100`}>
        <div className={classes.bordered}>
          <OverallStudentAnalysis/>
        </div>
      </div>
    </div>
  );
};

export default OverallAnalytics;
